import styled from 'styled-components'

import Modal from '../Modal'
import AdsReplyForm from '../../forms/AdsReplyForm'
import { Wrapper } from '../Modal/styled'

export const ModalStyled = styled(Modal)`
  ${Wrapper} {
    max-width: 70rem;
    width: 100%;
  }
`
export const Form = styled(AdsReplyForm)`
  margin-top: 2.4rem;
`
